/* eslint-disable */
import type { Image } from "../../cash/ui/Image.pb";

/** Blocker used to present a tutorial experience. */
export interface TutorialBlocker {
  pages?: TutorialBlockerPage[];
  next_page_button_text?: string;
  submit_button_text?: string;
  /**
   * Optional. If this field is present, the client will do the following
   * when the submit button is tapped:
   *   1) End the flow
   *   2) Send a FinishTutorialRequest
   *      - The client will not wait for the response
   *        or expect any blockers to be returned.
   *        the client only calls this endpoint to let
   *        server know that the customer has seen the
   *        tutorial.
   *      - It is possible this request will fail. In
   *        that event, the customer may see the
   *        tutorial twice.
   *   3) Evaluate the client route.
   */
  client_route_url?: string;
}

export interface TutorialBlockerPage {
  illustration?: TutorialBlockerPageIllustration | undefined;
  remote_image?: Image | undefined;
  title?: string;
  description?: string;
}

export enum TutorialBlockerPageIllustration {
  INSTANT_PAY_GET_PART_OF_YOUR_PAY_NOW = "INSTANT_PAY_GET_PART_OF_YOUR_PAY_NOW",
  INSTANT_PAY_GET_THE_REST_ON_PAYDAY = "INSTANT_PAY_GET_THE_REST_ON_PAYDAY",
  INSTANT_PAY_AND_ITS_FREE = "INSTANT_PAY_AND_ITS_FREE",
  INSTANT_PAY_YOURE_APPROVED = "INSTANT_PAY_YOURE_APPROVED",
  BORROW_UP_TO_AMOUNT = "BORROW_UP_TO_AMOUNT",
  BORROW_PAY_BACK_OVER_TIME = "BORROW_PAY_BACK_OVER_TIME",
  BORROW_TRY_IT_OUT_FOR_FREE = "BORROW_TRY_IT_OUT_FOR_FREE",
}
